import {
    BottomSheetContent as L2RBottomSheetContent,
    styled,
} from "@l2r-front/l2r-ui"

export const SideComponentContainer = styled("div")(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(1),
}))

export const BottomSheetContent = styled(L2RBottomSheetContent)(() => ({
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    position: "relative",
}))                                                                         